// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://gxjhhfllwtodskynhorr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd4amhoZmxsd3RvZHNreW5ob3JyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE0OTg2NjAsImV4cCI6MjA1NzA3NDY2MH0.mg_8gXMXwEgZ0Cng7TVzm9q3-7xM6eQzCkTiF4CTaGc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);